import { render, staticRenderFns } from "./RecordPanel.vue?vue&type=template&id=1d80425f"
import script from "./RecordPanel.vue?vue&type=script&lang=js"
export * from "./RecordPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports